"use client";
import { useAuthModal } from "@/context/AuthModalContext";
import { useUserContext } from "@/context/UserContext";
import { useEffect } from "react";

interface OpenRegister {
  referral?: string;
}
export const OpenRegister = ({ referral }: OpenRegister) => {
  const { currentUser, userLoader } = useUserContext();
  const { setAuthModal } = useAuthModal();
  useEffect(() => {
    if (referral && !userLoader && !currentUser) {
      setAuthModal({ show: true, form: "signUp", referralId: referral });
    }
  }, [referral, currentUser, userLoader]);

  return null;
};
